module.exports = __webpack_public_path__ + "img/social.5bf300e7.png";